module.exports = __webpack_public_path__ + "img/img3.a8cb9e79.jpg";